var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.956L12 15 0 2.956 1.949 0 12 10.088 22.051 0z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDI0IDE0Ij4KICA8cG9seWdvbiBwb2ludHM9IjUzMyA0ODMuOTU2IDUyMSA0OTYgNTA5IDQ4My45NTYgNTEwLjk0OSA0ODEgNTIxIDQ5MS4wODggNTMxLjA1MSA0ODEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MDkgLTQ4MSkiLz4KPC9zdmc+Cg==";
export { SvgArrowDown as ReactComponent };